import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import AdminUpdatesPopup from "../admin/updates/AdminUpdatesPopup";
import {
  canAccessAllowedRole,
  getHomeRouteForRole,
  normalizeAccessType,
} from "../../utils/accessControl";

export default function RequireRole({ allowed = [] }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  const role = normalizeAccessType(user.access_type);
  const normalizedAllowed = allowed.map(normalizeAccessType);
  const ok = canAccessAllowedRole(role, normalizedAllowed);
  const showUpdatesPopup = ok;

  if (!ok) return <Navigate to={getHomeRouteForRole(role)} replace />;

  return (
    <>
      {showUpdatesPopup ? <AdminUpdatesPopup user={user} role={role} /> : null}
      <Outlet />
    </>
  );
}
